import type { NetworkPayload } from "../../../composites";

export const API = {
  parseCSV: (payload: API.ACHImport.CSVParseRequest): NetworkPayload => {
    return {
      url: "ach_import/csv/parse/",
      options: {
        method: "POST",
        payload,
      },
    };
  },

  fetchMappings: (): NetworkPayload => {
    return {
      url: "ach_import/csv/mappings/",
      options: {
        method: "GET",
      },
    };
  },

  createMapping: (
    payload: API.ACHImport.CSVFieldMappingRequest,
  ): NetworkPayload => {
    return {
      url: "ach_import/csv/mappings/",
      options: {
        method: "POST",
        payload,
      },
    };
  },

  updateMapping: (
    uuid: string,
    payload: API.ACHImport.CSVFieldMappingRequest,
  ): NetworkPayload<API.ACHImport.CSVFieldMappingRequest> => {
    return {
      url: `ach_import/csv/mappings/${uuid}/`,
      options: {
        method: "PUT",
        payload,
      },
    };
  },

  deleteMapping: (uuid: string): NetworkPayload => {
    return {
      url: `ach_import/csv/mappings/${uuid}/`,
      options: {
        method: "DELETE",
        isJsonResponse: false,
      },
    };
  },
};
